import { Skeleton } from "antd"
import cls from "classname"
import { useSelector } from "react-redux"

import shellStyles from "../../shell.module.less"
import styles from "./wizardSkeleton.module.less"

// Full-page placeholder shown until the first Configure GET completes. Mirrors
// the real 3-column wizard (rail + form + preview + footer) so nothing shifts
// on hydration and the merchant sees the shape they're about to interact with.
// Mobile switches the rail to the compact horizontal stepper LeftRail renders
// there (5 badge circles + step-name meta row) and drops the preview column —
// same shape as the live component.
const StepRowSkeleton = () => (
  <div className={cls(shellStyles.sectionItem, styles.skStep)}>
    <Skeleton.Avatar active size={28} shape="circle" />
    <div className={styles.skStepMeta}>
      <Skeleton.Button active size="small" style={{ width: 48, height: 12 }} />
      <Skeleton.Button active size="small" style={{ width: 130, height: 14 }} />
    </div>
    <Skeleton.Button active size="small" style={{ width: 36, height: 14 }} />
  </div>
)

// Mirrors LeftRail's MobileStepper: 5 small badge circles in a row (with the
// connector line drawn by .mobileStepperBadges::before) + a caption row.
const MobileStepperSkeleton = () => (
  <div className={shellStyles.mobileStepper}>
    <div className={shellStyles.mobileStepperBadges}>
      {[0, 1, 2, 3, 4].map((i) => (
        <Skeleton.Avatar key={i} active size={32} shape="circle" />
      ))}
    </div>
    <div className={shellStyles.mobileStepperMeta}>
      <Skeleton.Button active size="small" style={{ width: 56, height: 12 }} />
      <Skeleton.Button active size="small" style={{ width: 60, height: 14 }} />
    </div>
  </div>
)

const FieldSkeleton = () => (
  <div className={styles.skField}>
    <Skeleton.Button active size="small" style={{ width: 140, height: 14 }} />
    <Skeleton.Input active block style={{ height: 40 }} />
  </div>
)

const WizardSkeleton = () => {
  const isMobile = useSelector((s) => !!s.nav?.isMobile)

  return (
    <div className={cls(shellStyles.wizard, styles.skWizard)}>
      <aside className={shellStyles.rail}>
        <div className={shellStyles.railTop}>
          <div className={shellStyles.sectionGroup}>
            <div className={shellStyles.stepsList}>
              {isMobile ? (
                <MobileStepperSkeleton />
              ) : (
                [0, 1, 2, 3, 4].map((i) => <StepRowSkeleton key={i} />)
              )}
            </div>
          </div>
        </div>
      </aside>

      <div className={shellStyles.main}>
        <div className={shellStyles.mainScroll}>
          <div className={shellStyles.sectionForm}>
            <div className={shellStyles.sectionFormHead}>
              <Skeleton.Button active style={{ width: 220, height: 28 }} />
              <Skeleton.Button active style={{ width: 320, height: 16 }} />
            </div>
            <div className={styles.skFields}>
              {[0, 1, 2].map((i) => (
                <FieldSkeleton key={i} />
              ))}
            </div>
          </div>
        </div>

        <div className={shellStyles.footer}>
          <div className={shellStyles.footerLeft}>
            <div className={cls(styles.skFooterBtn, styles.skFooterSave)}>
              <Skeleton.Button active block />
            </div>
          </div>
          <div className={shellStyles.footerCenter} />
          <div className={shellStyles.footerRight}>
            <div className={cls(styles.skFooterBtn, styles.skFooterPrev)}>
              <Skeleton.Button active block />
            </div>
            <div className={cls(styles.skFooterBtn, styles.skFooterNext)}>
              <Skeleton.Button active block />
            </div>
          </div>
        </div>
      </div>

      {isMobile ? null : (
        <aside className={styles.skPreview}>
          <Skeleton.Button active block style={{ height: "100%" }} />
        </aside>
      )}
    </div>
  )
}

export default WizardSkeleton
